import type { RouteLocationNormalizedLoaded } from 'vue-router'

const SITE = '장기요양지원센터'

function metaString(meta: Record<string, unknown>, key: string): string {
  const value = meta[key]
  return typeof value === 'string' && value.trim() ? value.trim() : ''
}

function layoutOf(route: RouteLocationNormalizedLoaded): string {
  for (let i = route.matched.length - 1; i >= 0; i -= 1) {
    const layout = route.matched[i]?.meta?.layout
    if (typeof layout === 'string' && layout) return layout
  }
  return typeof route.meta.layout === 'string' ? route.meta.layout : ''
}

/** 브라우저 탭 제목 — 관리자 / 판매관리센터를 바로 구분할 수 있게 한다 */
export function documentTitleOf(route: RouteLocationNormalizedLoaded): string {
  const layout = layoutOf(route)
  const path = route.path || ''
  const page =
    metaString(route.meta as Record<string, unknown>, 'sellerTitle') ||
    metaString(route.meta as Record<string, unknown>, 'adminTitle') ||
    metaString(route.meta as Record<string, unknown>, 'visitLabel') ||
    String(route.name || '')

  if (layout === 'seller' || path.startsWith('/seller') || route.name === 'signup-seller') {
    return page ? `${page} · 판매관리센터` : '판매관리센터'
  }

  if (layout === 'admin' || path.startsWith('/admin')) {
    return page ? `${page} · 관리자` : '관리자'
  }

  if (layout === 'mall' || path.startsWith('/mall')) {
    return page ? `${page} · 함우리몰` : '함우리몰'
  }

  if (!page || page === '홈' || route.name === 'landing') {
    return SITE
  }

  return `${page} · ${SITE}`
}

export function applyDocumentTitle(route: RouteLocationNormalizedLoaded) {
  document.title = documentTitleOf(route)
}
